import "./imageslider.css";
import Bab16 from "./Images/Bab16.webp";
import Mat8 from "./Images/Mat8.webp";
import Wed31 from "./Images/Wed31.webp";
import Out20 from "./Images/Out20.webp";
import Mat7 from "./Images/Mat7.webp";
import Out4 from "./Images/Out4.webp";
import Bab27 from "./Images/Bab27.webp";
import Wed36 from "./Images/Wed36.webp";
import Wed33 from "./Images/Wed31.webp";
import Bab9 from "./Images/Bab9.webp";
const images = [ Bab9,Wed31, Bab27,Mat8,Wed36,Wed31,Mat7,Out4,Bab16,Out20];

function ImageSlider() {
  return (
    <div className="imslider-wrapper">
      <div className="imslider-track">
        {[...images, ...images].map((src, idx) => (
          <div className="imslider-item" key={idx}>
            <img src={src} alt={`slide-${idx}`} loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ImageSlider;
